import request from "root/js/request";

export const getProductCardPromotionDynamic = async ({
  cabinet_id,
  date_from,
  date_to,
  period,
  in_product_id,
  in_product_id__in,
  source,
  source__in,
  value,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/advert_dynamic/",
    method: "get",
    params: {
      cabinet_id,
      date_from,
      date_to,
      period,
      in_product_id,
      in_product_id__in,
      source,
      source__in,
      value,
      ...rest,
    },
  });
  return response.data;
};
